import React, {
    useState, useEffect
} from 'react';

import {
    LayoutDashboard, Cctv, ShieldAlert, BarChart3, LogOut, ChevronLeft, Menu, HardHat, Settings, Globe, Briefcase, BookOpen, Image as ImageIcon, Map, Sun, Moon, Users, FileText, Calendar, UserCheck, Layers, Calculator, DollarSign, Bell, Truck
} from 'lucide-react';

import {
    useNavigate
} from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import axios from 'axios';
import SupportChatWidget from '../components/SupportChatWidget';

const MainLayout = ({
    children
}) => {
    const [isCollapsed, setIsCollapsed] = useState(true);
    const [activeProjectName, setActiveProjectName] = useState(() => {
        return localStorage.getItem('activeProjectName') || 'Proyecto Default';
    });
    const [logoUrl, setLogoUrl] = useState(null);
    const navigate = useNavigate();
    const { isDarkMode, toggleTheme } = useTheme();

    // Estado para forzar cambio de contraseña temporal
    const [showForcePassword, setShowForcePassword] = useState(() => {
        return localStorage.getItem('mustChangePassword') === 'true';
    });
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [pwError, setPwError] = useState('');
    const [pwLoading, setPwLoading] = useState(false);

    const handleForceChangePassword = async (e) => {
        e.preventDefault();
        setPwError('');
        if (newPassword.length < 6) {
            setPwError('La contraseña debe tener al menos 6 caracteres.');
            return;
        }
        if (newPassword !== confirmPassword) {
            setPwError('Las contraseñas no coinciden.');
            return;
        }

        setPwLoading(true);
        try {
            const token = localStorage.getItem('token');
            await axios.post('http://localhost:4000/api/auth/change-password', {
                newPassword
            }, {
                headers: { Authorization: `Bearer ${token}` }
            });
            localStorage.removeItem('mustChangePassword');
            setShowForcePassword(false);
            alert('Contraseña actualizada con éxito. Ya puedes utilizar la plataforma.');
        } catch (err) {
            setPwError(err.response?.data?.error || 'Error al actualizar la contraseña.');
        } finally {
            setPwLoading(false);
        }
    };

    useEffect(() => {
        const fetchProjectLogo = async () => {
            const token = localStorage.getItem('token');
            const activeProjectId = localStorage.getItem('activeProjectId');
            if (!token || !activeProjectId) return;

            try {
                const res = await axios.get('http://localhost:4000/api/projects', {
                    headers: { Authorization: `Bearer ${token}` }
                });
                const activeProj = res.data.find(p => p.id === parseInt(activeProjectId));
                if (activeProj && activeProj.logo_url) {
                    setLogoUrl(activeProj.logo_url);
                }
            } catch (err) {
                console.error("Error al obtener logotipo del proyecto en MainLayout:", err);
            }
        };
        fetchProjectLogo();
    }, []);

    useEffect(() => {
        const checkActiveProject = async () => {
            const currentProjectId = localStorage.getItem('activeProjectId');
            const token = localStorage.getItem('token');
            const role = localStorage.getItem('userRole');

            if (token && !currentProjectId && (role === 'PROJECT_MANAGER' || role === 'DEMO_USER' || role === 'VIEWER')) {
                try {
                    const res = await axios.get('http://localhost:4000/api/projects');
                    if (res.data && res.data.length > 0) {
                        localStorage.setItem('activeProjectId', res.data[0].id);
                        localStorage.setItem('activeProjectName', res.data[0].name);
                        setActiveProjectName(res.data[0].name);
                        window.location.reload();
                    }
                } catch (err) {
                    console.error("Error al obtener proyecto por defecto en MainLayout:", err);
                }
            }
        };
        checkActiveProject();
    }, []);

    const handleLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('userRole');
        localStorage.removeItem('activeProjectId');
        localStorage.removeItem('activeProjectName');
        navigate('/login');
    };
    const userRole = localStorage.getItem('userRole') || 'VIEWER';
    const allMenuItems = [{
        icon: <Briefcase size={22} />, label: 'Mis Proyectos', path: '/projects', roles: ['COMPANY_ADMIN']
    }, {
        icon: <Globe size={22} />, label: 'Consola Global', path: '/admin-global', roles: ['SUPER_ADMIN']
    }, {
        icon: <Users size={22} />, label: 'Clientes y Obras', path: '/admin/companies', roles: ['SUPER_ADMIN']
    }, {
        icon: <DollarSign size={22} />, label: 'Facturación SaaS', path: '/admin/billing', roles: ['SUPER_ADMIN']
    }, {
        icon: <Cctv size={22} />, label: 'Monitoreo Cámaras', path: '/admin/cameras', roles: ['SUPER_ADMIN']
    }, {
        icon: <ShieldAlert size={22} />, label: 'Seguridad e Infra', path: '/admin/security', roles: ['SUPER_ADMIN']
    }, {
        icon: <LayoutDashboard size={22} />, label: 'Obra Activa', path: '/dashboard', roles: ['COMPANY_ADMIN', 'PROJECT_MANAGER', 'VIEWER', 'DEMO_USER']
    }, {
        icon: <ImageIcon size={22} />, label: 'Fotos y Timelapses', path: '/photos', roles: ['COMPANY_ADMIN', 'PROJECT_MANAGER', 'VIEWER', 'DEMO_USER']
    }, {
        icon: <Map size={22} />, label: 'Planos de Obra', path: '/blueprints', roles: ['COMPANY_ADMIN', 'PROJECT_MANAGER', 'VIEWER', 'DEMO_USER']
    }, {
        icon: <BookOpen size={22} />, label: 'Bitácora de Obra', path: '/bitacora', roles: ['COMPANY_ADMIN', 'PROJECT_MANAGER', 'VIEWER', 'DEMO_USER']
    }, {
        icon: <Cctv size={22} />, label: 'Cámaras en Vivo', path: '/cameras', roles: ['COMPANY_ADMIN', 'PROJECT_MANAGER', 'VIEWER', 'DEMO_USER']
    }, {
        icon: <Truck size={22} />, label: 'Control de Accesos', path: '/logistics', roles: ['SUPER_ADMIN', 'COMPANY_ADMIN', 'PROJECT_MANAGER', 'DEMO_USER']
    }, {
        icon: <ShieldAlert size={22} />, label: 'Seguridad EHS', path: '/security', roles: ['COMPANY_ADMIN', 'PROJECT_MANAGER', 'VIEWER', 'DEMO_USER']
    }, {
        icon: <Calendar size={22} />, label: 'Cronograma Gantt', path: '/gantt', roles: ['COMPANY_ADMIN', 'PROJECT_MANAGER', 'VIEWER', 'DEMO_USER']
    }, {
        icon: <UserCheck size={22} />, label: 'Asistencia Cuadrillas', path: '/attendance', roles: ['COMPANY_ADMIN', 'PROJECT_MANAGER', 'VIEWER', 'DEMO_USER']
    }, {
        icon: <Layers size={22} />, label: 'Visor 3D BIM', path: '/bim', roles: ['COMPANY_ADMIN', 'PROJECT_MANAGER', 'VIEWER', 'DEMO_USER']
    }, {
        icon: <Calculator size={22} />, label: 'Estimaciones y Avance', path: '/estimations', roles: ['COMPANY_ADMIN', 'PROJECT_MANAGER', 'VIEWER', 'DEMO_USER']
    }, {
        icon: <Bell size={22} />, label: 'Alertas y Webhooks', path: '/admin-alerts', roles: ['SUPER_ADMIN']
    }, {
        icon: <BookOpen size={22} />, label: 'Manuales y Wiki', path: '/wiki', roles: ['SUPER_ADMIN', 'COMPANY_ADMIN', 'PROJECT_MANAGER', 'VIEWER', 'DEMO_USER']
    }, {
        icon: <Settings size={22} />, label: 'Configuración', path: '/settings', roles: ['COMPANY_ADMIN', 'PROJECT_MANAGER', 'DEMO_USER']
    },];
    const menuItems = allMenuItems.filter(item => item.roles.includes(userRole));
    return (<div className="flex h-screen overflow-hidden font-sans bg-theme-bg text-theme-text-primary"> {
        /* SIDEBAR */
    } <aside className={
        `bg-theme-panel transition-all duration-300 flex flex-col z-20 ${isCollapsed ? 'w-20' : 'w-64'
        }`
    }>
            <div className="flex flex-col items-center justify-center py-6 mb-2 border-b border-theme-border">
                {isCollapsed ? (
                    <div className="flex items-center justify-center w-12 h-12">
                        <img 
                            src={logoUrl || (isDarkMode ? "/logo-blanco-mark.png" : "/logo-color.png")} 
                            alt="Archi" 
                            className="w-10 h-10 object-contain rounded-lg" 
                        />
                    </div>
                ) : (
                    <div className="flex flex-col items-center justify-center px-4 w-full">
                        <img 
                            src={logoUrl || (isDarkMode ? "/logo-blanco-mark.png" : "/logo-color.png")} 
                            alt="Archi" 
                            className="h-16 w-auto object-contain mb-3 rounded-lg" 
                        />
                        {!logoUrl && (
                            <div className="font-sans text-center select-none leading-none tracking-tight">
                                <span className={`text-xl font-black uppercase tracking-wider ${
                                    isDarkMode ? 'text-[#dddddd]' : 'text-[#1a2a3c]'
                                }`}>ARCHI</span>
                                <span className={`text-xl font-light ml-1.5 ${
                                    isDarkMode ? 'text-[#FFFFFF]' : 'text-[#bea16d]'
                                }`}>24/7</span>
                            </div>
                        )}
                    </div>
                )}
            </div> {
                /* Navigation */
            } <nav className="flex-1 px-3 py-4 space-y-1.5 overflow-y-auto custom-scrollbar"> {
                menuItems.map((item) => (<button key={
                    item.label
                } onClick={
                    () => navigate(item.path)
                } className="w-full flex items-center p-3 rounded-2xl hover: hover:text-theme-text-primary transition-all group relative border border-transparent" > <div className="text-theme-text-secondary group-hover:text-blue-400 transition-colors"> {
                    item.icon
                } </div> {
                        !isCollapsed && <span className="ml-4 font-semibold text-sm tracking-wide">{
                            item.label
                        }</span>
                    } {
                        /* Tooltip cuando está colapsado */
                    } {
                        isCollapsed && (<div className="absolute left-full ml-4 px-3 py-1.5 bg-blue-600 text-theme-text-primary text-xs font-bold rounded-lg opacity-0 group-hover:opacity-100 pointer-events-none transition-all shadow-xl whitespace-nowrap z-50"> {
                            item.label
                        } </div>)
                    } </button>))
            } </nav> {
                /* Bottom Actions */
            } <div className="p-3 space-y-1">
                <button onClick={
                    () => setIsCollapsed(!isCollapsed)
                } className="w-full flex items-center p-3 rounded-xl hover:bg-theme-border text-theme-text-secondary hover:text-theme-text-primary transition-colors" > {
                        isCollapsed ? <Menu size={
                            22
                        } /> : <ChevronLeft size={
                            22
                        } />
                    } {
                        !isCollapsed && <span className="ml-4 font-medium text-sm">Contraer</span>
                    } </button> <button onClick={
                        handleLogout
                    } className="w-full flex items-center p-3 rounded-xl hover:bg-red-500/10 text-red-500 transition-colors" > <LogOut size={
                        22
                    } /> {
                        !isCollapsed && <span className="ml-4 font-medium text-sm">Cerrar Sesión</span>
                    } </button> </div> </aside> {
            /* CONTENT AREA */
        } <div className="flex-1 flex flex-col min-w-0"> {
            /* TOPBAR */
        } <header className="h-20 bg-theme-panel flex items-center justify-between px-8 z-10 shadow-sm shadow-[#00000021] dark:shadow-none"> <div className="flex items-center gap-4"> {userRole === 'SUPER_ADMIN' ? (
            <div>
                <h2 className="text-[10px] font-black text-purple-500 uppercase tracking-widest mb-1">Nivel de Acceso</h2>
                <p className="text-lg font-bold text-theme-text-primary tracking-tight">Consola de Control Global</p>
            </div>
        ) : (
            <div>
                <h2 className="text-[10px] font-black text-blue-500 uppercase tracking-widest mb-1">Centro de Trabajo Activo</h2>
                <p className="text-lg font-bold text-theme-text-primary tracking-tight">{activeProjectName}</p>
            </div>
        )}
        {userRole === 'DEMO_USER' && <div className="bg-yellow-500/10 border border-yellow-500/30 text-yellow-500 px-3 py-1 rounded-full text-xs font-bold tracking-widest animate-pulse">MODO DEMO (SOLO LECTURA)</div>}
        </div>
        <div className="flex items-center gap-6">
            <button onClick={toggleTheme} className="p-2.5 rounded-xl bg-theme-bg hover:bg-theme-panel transition-all group">
                {isDarkMode ? <Sun size={20} className="text-yellow-400 group-hover:scale-110 transition-transform" /> : <Moon size={20} className="text-indigo-400 group-hover:scale-110 transition-transform" />}
            </button>
            <div className="flex flex-col items-end">
                <span className="text-xs font-bold text-slate-600 text-theme-text-secondary uppercase tracking-widest">Estado</span>
                <span className="text-xs font-bold text-emerald-400 flex items-center gap-2 mt-1 bg-emerald-500/10 px-2.5 py-1 rounded-md border border-emerald-500/20">
                    <span className="w-1.5 h-1.5 bg-emerald-400 rounded-full animate-pulse shadow-[0_0_8px_rgba(52,211,153,0.8)]"></span> Sistema Online
                </span>
            </div>
        </div>
        </header>

        <main className="flex-1 overflow-y-auto bg-theme-bg">
            {children}
        </main>
        </div>

        {/* FORCED PASSWORD CHANGE MODAL OVERLAY */}
        {showForcePassword && (
            <div className="fixed inset-0 bg-black/80 backdrop-blur-md flex items-center justify-center p-4 z-[9999] pointer-events-auto">
                <div className="bg-theme-panel border border-theme-border w-full max-w-md rounded-3xl p-8 shadow-2xl relative">
                    <div className="text-center mb-6">
                        <div className="w-16 h-16 bg-blue-500/10 text-blue-500 rounded-full flex items-center justify-center mx-auto mb-4 border border-blue-500/30">
                            <HardHat size={32} />
                        </div>
                        <h3 className="text-xl font-black text-theme-text-primary">Establece tu Contraseña</h3>
                        <p className="text-xs text-theme-text-secondary mt-2">
                            Por razones de seguridad, debes cambiar la contraseña temporal de 24 horas antes de acceder a la plataforma.
                        </p>
                    </div>

                    {pwError && (
                        <div className="bg-red-500/10 border border-red-500/50 text-red-500 text-xs font-bold px-4 py-2.5 rounded-xl mb-4 text-center">
                            {pwError}
                        </div>
                    )}

                    <form onSubmit={handleForceChangePassword} className="space-y-4">
                        <div>
                            <label className="block text-xs font-bold text-theme-text-secondary uppercase tracking-wider mb-1.5">Nueva Contraseña</label>
                            <input
                                type="password"
                                required
                                minLength={6}
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                                className="w-full bg-theme-bg border border-theme-border text-theme-text-primary px-4 py-2.5 rounded-xl focus:outline-none focus:border-blue-500 transition-colors"
                                placeholder="Mínimo 6 caracteres"
                            />
                        </div>
                        <div>
                            <label className="block text-xs font-bold text-theme-text-secondary uppercase tracking-wider mb-1.5">Confirmar Contraseña</label>
                            <input
                                type="password"
                                required
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                className="w-full bg-theme-bg border border-theme-border text-theme-text-primary px-4 py-2.5 rounded-xl focus:outline-none focus:border-blue-500 transition-colors"
                                placeholder="Confirma tu contraseña"
                            />
                        </div>
                        <button
                            type="submit"
                            disabled={pwLoading}
                            className="w-full bg-blue-600 hover:bg-blue-500 text-theme-text-primary font-bold py-3 mt-2 rounded-xl transition-all flex items-center justify-center gap-2 cursor-pointer shadow-lg"
                        >
                            {pwLoading ? <span className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></span> : 'Establecer Contraseña Permanente'}
                        </button>
                    </form>
                </div>
            </div>
        )}

        {/* CHATBOT DE SOPORTE FLOTANTE */}
        <SupportChatWidget />
    </div>
);
};

export default MainLayout;
